import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row, Table, Pagination, Modal } from "antd";
import Filter from "../../../components/filter/Filter";
import { deleteSpecialty, getSpecialtysList } from "../../../redux/slices/specialtys/specialtysThunk";
import { columns } from "./columns";

const SpecialtiesPage = () => {

  const specialtysData = useSelector((state) => state.specialtys.specialtys);
  const specialtysData_loading = useSelector((state) => state.specialtys.loading);
  const totalItems = useSelector((state) => state.specialtys.specialtys?.total);

  const [search, setSearch] = useState({
    searchTerm: "",
  });

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
  });

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(getSpecialtysList({
      page: pagination.currentPage,
      itemsPerPage: 10,
      filter: {
        search: search.searchTerm
      }
    }));
  }, [dispatch, pagination.currentPage, search.searchTerm]);


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemId, setItemId] = useState(null);

  const showModal = (id) => {
    setIsModalOpen(true);
    setItemId(id);
  };

  const handlePagination = (page) => {
    setPagination(prev => ({ ...prev, currentPage: page }));
  };

  const navigateTo = (path) => {
    history.push(path);
  };

  const handleDelete = (id) => {
    dispatch(deleteSpecialty(id)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(getSpecialtysList({
          page: pagination.currentPage,
          itemsPerPage: pagination.pageSize,
          filter: {
            search: search.searchTerm
          }
        }))
      } else if (result.meta.requestStatus === "rejected") {
      }
    });
    setIsModalOpen(false);
  };
  const handleSearchedValue = (value, key) => {
    if (search[key] !== value) {
      setSearch((prevSearch) => ({
        ...prevSearch,
        [key]: value,
      }));
      if (key === "searchTerm")
        setPagination((prevPagination) => ({
          ...prevPagination,
          currentPage: 1, // Reset page to 1 when filter changes
        }));
    }
  };
  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title="Liste des spécialités"
            extra={
              <Button
                type="primary"
                onClick={() => navigateTo("/nouvelle/spécialité")}
              >
                <PlusOutlined />
                Ajouter une spécialité
              </Button>
            }
          />
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={
              <Filter
                searchPlaceholder="Rechercher"
                onSearchValue={handleSearchedValue}
              />
            }
          >
            <Table
              columns={columns(navigateTo, showModal)}
              dataSource={specialtysData?.data}
              className="ant-border-space"
              pagination={false}
              scroll={{ x: 240 }}
              rowKey={(record) => record.id}
              loading={specialtysData_loading}
            />
          </Card>
          <Pagination
            current={pagination.currentPage}
            total={totalItems}
            pageSize={10}
            onChange={handlePagination}
          />
        </Col>
        <Modal
          title="Supprimer une spécialité"
          visible={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={[
            <Button key="back" onClick={() => setIsModalOpen(false)}>
              Annuler
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={() => handleDelete(itemId)}
            >
              Supprimer
            </Button>,
          ]}
        >
          <p>Êtes-vous sûr de vouloir supprimer cette spécialité ?</p>
        </Modal>
      </Row>
    </div>
  );
};

export default SpecialtiesPage;
